import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

import * as styles from '@twisto/styles'

export const root = css`
  padding: 0;
  margin: 0;
  list-style: none;
`

export const listItem = css`
  margin-bottom: ${styles.size[8]};
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`

export const listItemText = (theme: Theme) => css`
  margin: ${styles.size[0]} ${styles.size[8]};
  color: ${theme.palette.neutral[800]};
`

export const checkedListItemText = (theme: Theme) => css`
  color: ${theme.palette.neutral[700]};
  text-decoration: line-through;
`

export const listItemIcon = (theme: Theme) => css`
  display: flex;
  color: ${theme.palette.neutral[800]};
  width: ${styles.size[20]};
  height: ${styles.size[20]};
`
